import { render, staticRenderFns } from "./Comentarios.vue?vue&type=template&id=016183fc"
import script from "./Comentarios.vue?vue&type=script&lang=js"
export * from "./Comentarios.vue?vue&type=script&lang=js"
import style0 from "./Comentarios.vue?vue&type=style&index=0&id=016183fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports